const initialState = {
	data: [],
	total: 0,
	params: {},
}

const playerreferral = (state = initialState, action) => {
	switch (action.type) {
		case 'PLAYERREFERRAL_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		default:
			return state
	}
}

export default playerreferral
